module.exports = __webpack_public_path__ + "media/assets/player/X-320aab129585eb01b953cad065e866b3.png";